import { render, staticRenderFns } from "./BtnUPAndDown.vue?vue&type=template&id=71e60cca&scoped=true"
import script from "./BtnUPAndDown.vue?vue&type=script&lang=js"
export * from "./BtnUPAndDown.vue?vue&type=script&lang=js"
import style0 from "./BtnUPAndDown.vue?vue&type=style&index=0&id=71e60cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e60cca",
  null
  
)

export default component.exports